"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledRoot = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "orientation";
  }
})(function (_ref) {
  var theme = _ref.theme,
      orientation = _ref.orientation;
  return {
    "& > * + *": {
      marginLeft: orientation === "horizontal" ? theme.spacing(3) : 0,
      marginTop: orientation === "vertical" ? theme.spacing(3) : 0
    },
    display: "flex",
    flexDirection: orientation === "horizontal" ? "row" : "column"
  };
});
var StyledRadioContainer = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "widthFill" && prop !== "checked" && prop !== "disabled";
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      widthFill = _ref2.widthFill,
      checked = _ref2.checked,
      disabled = _ref2.disabled;
  return {
    "& label": {
      margin: disabled ? "2px !important" : 0,
      cursor: disabled ? "not-allowed" : "pointer"
    },
    "&:focus-visible": {
      borderColor: theme.palette.focusRing.main
    },
    "&:hover": {
      borderColor: disabled ? theme.palette.brand.grey.lightGrey : theme.palette.primary.main
    },
    borderColor: checked ? theme.palette.primary.main : theme.palette.brand.grey.lightGrey,
    borderWidth: "3px",
    borderStyle: "solid",
    background: disabled ? theme.palette.brand.grey.lightGrey : theme.palette.common.white,
    borderRadius: 8,
    cursor: disabled ? "not-allowed" : "pointer",
    display: "flex",
    flexGrow: widthFill ? 1 : 0,
    outline: "none",
    padding: "".concat(theme.spacing(3), " !important")
  };
});
var StyledRadio = (0, _material.styled)(_material.Radio)(function () {
  return {
    "&:hover": {
      backgroundColor: "unset"
    },
    padding: 0
  };
});
var StyledRadioLabel = (0, _material.styled)("label")(function () {
  return {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    maxWidth: "25rem"
  };
});
var StyledContainer = (0, _material.styled)(_material.Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginLeft: theme.spacing(3)
  };
});

var RadioCard = function RadioCard(_ref4) {
  var cards = _ref4.cards,
      onChange = _ref4.onChange,
      checked = _ref4.checked,
      widthFill = _ref4.widthFill,
      _ref4$orientation = _ref4.orientation,
      orientation = _ref4$orientation === void 0 ? "horizontal" : _ref4$orientation,
      RootProps = _ref4.RootProps,
      RadioContainerProps = _ref4.RadioContainerProps;

  var onChangeHandler = function onChangeHandler(card) {
    if (card.disabled || checked === card.value) {
      return;
    }

    onChange(card.value);
  };

  var _onKeyPress = function onKeyPress(e, card) {
    var isSpace = e.key === "Spacebar" || e.which === 32;

    if (isSpace) {
      e.preventDefault();
      onChangeHandler(card);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRoot, _objectSpread(_objectSpread({
    orientation: orientation
  }, RootProps), {}, {
    children: cards.map(function (card) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRadioContainer, _objectSpread(_objectSpread({
        checked: checked === card.value,
        disabled: card.disabled,
        onClick: function onClick() {
          return onChangeHandler(card);
        },
        onKeyPress: function onKeyPress(e) {
          return _onKeyPress(e, card);
        },
        role: "button",
        tabIndex: card.disabled ? -1 : 0,
        widthFill: widthFill
      }, RadioContainerProps), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRadioLabel, {
          htmlFor: "radio-".concat(card.value),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRadio, {
            checked: checked === card.value,
            color: "primary",
            disabled: card.disabled,
            id: "radio-".concat(card.value),
            tabIndex: -1,
            value: card.value
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContainer, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              variant: "subtitle2",
              children: card.title
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              variant: "body3",
              children: card.description
            })]
          })]
        })
      }), card.value);
    })
  }));
};

var _default = RadioCard;
exports.default = _default;